// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__Et_HZ","overlay":"styles_overlay__cUQc9","alertBox":"styles_alertBox__dV87U","actions":"styles_actions__4mEnp"};